import jQuery from 'jquery';

window.jQuery = jQuery;
window.$ = jQuery;


// configure the class for runtime loading
if (!window.fbControls) window.fbControls = new Array();
window.fbControls.push(function (controlClass) {
  /**
   * Star rating class
   */
  class digitalSignature extends controlClass {

    static get definition() {
      return {
        icon: '🖊️',
        i18n: {
          default: 'Assinatura digital'
        }
      }
    }

    configure() {
    }

    /**
     * build a text DOM element, supporting other jquery text form-control's
     * @return DOM Element to be injected into the form.
     */
    build() {
      return "<div>"+
        "<input type='hidden' id='assinaturaDigital' name='assinatura' value='true'>"+
      "</div>"
    }

    onRender() {
      //let field = jQuery( "[name='assinatura']" );
      //console.log(field);
    }
  }

  // register this control for the following types & text subtypes
  controlClass.register('digitalSignature', digitalSignature);
  return digitalSignature;
});
